import { isAbsolute, relative, resolve, sep } from 'node:path';

/**
 * Resolve a model-supplied relative path to an absolute path INSIDE the repo, or
 * throw. Rejects absolute/UNC paths and `..` escapes (model tool-call args are
 * untrusted). Lexical check — a symlink-escape hardening pass is a later refinement.
 */
export function resolveInRepo(repoRoot: string, p: string): string {
  if (typeof p !== 'string' || p.length === 0) throw new Error('path is required');
  if (p.includes('\0')) throw new Error('invalid path');
  if (isAbsolute(p)) throw new Error('absolute paths are not allowed');
  const abs = resolve(repoRoot, p);
  const rel = relative(repoRoot, abs);
  // Check the path SEGMENT, not the string prefix, so a file merely *named* with
  // leading dots (e.g. `...eslintrc`) is allowed while `../` traversal is rejected.
  if (rel === '..' || rel.startsWith(`..${sep}`) || rel.startsWith('../') || isAbsolute(rel)) {
    throw new Error('path escapes the repository root');
  }
  return abs;
}
